import { encrypt } from "../../../../app/helpers"

export const returnDropDownItems = (
  vehicle: any,
  handleEditVehicle: (arg: any) => void,
) => {
  const vidAndTime = `${vehicle.vid}--${new Date().toISOString()}`
  const updateReminder = `Good day ${vehicle.name}, Have you renewed the expired papers/subscriptions of your ${vehicle.make} ${vehicle.model} (Reg. No.: ${vehicle.regNo})? Please confirm, so I can help update the database for future FREE reminders.

-CarPaddy team`

  const renewalReminder = `Hello ${vehicle.name}, your ${vehicle.make} ${
    vehicle.model
  } (Reg. No.: ${
    vehicle.regNo
  }) papers/subscriptions need to be renewed asap and we can help you renew usually within 48 hours and deliver afterwards. See the papers/subscriptions that have or will soon expire here: ${
    process.env.REACT_APP_URL
  }/rmdr/?v=${encrypt(vidAndTime, { strict: true })}

- CarPaddy team`
  const renewalReminderText = encodeURIComponent(renewalReminder)
  const updateReminderText = encodeURIComponent(updateReminder)
  const renewalReminderUrl = `https://api.whatsapp.com/send?phone=${vehicle.phone}&text=${renewalReminderText}&source=&data=`
  const updateReminderUrl = `https://api.whatsapp.com/send?phone=${vehicle.phone}&text=${updateReminderText}&source=&data=`

  const dropDownItems = [
    {
      label: "Renewal reminder",
      disabled: false,
      onClick: () => window.open(renewalReminderUrl, "_blank"),
    },
    {
      label: "Update reminder",
      disabled: false,
      onClick: () => window.open(updateReminderUrl, "_blank"),
    },
    {
      label: "Edit vehicle",
      onClick: () => handleEditVehicle(vehicle),
    },
  ]
  return dropDownItems
}
